<template>
    <div v-if="done">

        <InstructionCard v-for="alarm in alarmsJSON" :key="alarm.id" :alarm="alarm" :answer="(matchAnswer(alarm))"
            :status="matchAnswer(alarm) === undefined ? 'To do' : matchAnswer(alarm).field_alarm_status" class="mt-5"
            @update="submitAnswer" @delete="updateList"></InstructionCard>
    </div>
    <div v-else>
        {{ $t('_en_cours_de_chargement_') }}
    </div>
</template>

<script>
import InstructionCard from '@/components/Tech/InstructionCard.vue';
import backend from '@/api/backend';

export default {
    components: { InstructionCard },

    async beforeMount() {
        await this.fetchAlarms();
        await this.fetchAlarmsAnswers();
        this.done = true
    },

    data() {
        return {
            installation_id: this.$route.params.id,
            alarmsJSON: [],
            alarmsAnswersJSON: [],
            done: false
        }
    },

    methods: {
        async fetchAlarms() {
            try {
                const response = await backend.get_alarmquery_install(this.installation_id);
                this.alarmsJSON = response.data
            } catch (err) {
                console.log("Couldn't fetch alarms")
            }
        },

        async fetchAlarmsAnswers() {
            try {
                const response = await backend.get_alarm_install(this.installation_id);
                this.alarmsAnswersJSON = response.data
            } catch (err) {
                console.log("No answer")
            }
        },

        submitAnswer(alarmIndex, updatedAnswer) {
            this.alarmsAnswersJSON[this.getAnswerIndex(alarmIndex)] = { "id": alarmIndex, 'json_data': {} }
            this.$set(this.alarmsAnswersJSON[this.getAnswerIndex(alarmIndex)], 'json_data', updatedAnswer);
            this.$forceUpdate()
        },
        matchAnswer(alarm) {
            let id = alarm.id
            for (var answer in this.alarmsAnswersJSON) {
                if (this.alarmsAnswersJSON[answer].id === id) {
                    return this.alarmsAnswersJSON[answer].json_data
                }
            }
        },
        getAnswerIndex(alarmId) {

            for (var answer in this.alarmsAnswersJSON) {
                if (this.alarmsAnswersJSON[answer].id === alarmId) {
                    return answer
                }
            }
        },
        async updateList() {
            this.done = false
            this.alarmsJSON = {}
            this.alarmsAnswersJSON = {}
            await this.fetchAlarms();
            await this.fetchAlarmsAnswers();
            this.done = true
        }

    }

}

</script>
